import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { InternalErrorResponse } from '@/services/transport/types'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiNumberAlreadyUseError extends TmApiClientError<InternalErrorResponse> {
  public name = 'TmApiNumberAlreadyUseError'

  protected override code: TmTransportHttpErrorCode = 400

  public shouldBeMonitored(): boolean {
    return false
  }
}
